import React from "react";
import { Box } from "@mui/material";
import './bouncingLoader.css';

const BouncingDotsLoader = (props) => {
  const { sx = {} } = props; // Destructure the sx prop with a default value

  return (
    <Box
      className="bouncing-loader"
      sx={{
        display: 'flex',
        justifyContent: 'center',
        margin: '40px auto',
        '& > div': {
          width: sx.width || '12px',
          height: sx.height || '12px',
          margin: '3px 6px',
          borderRadius: '50%',
          backgroundColor: '#a3a1a1',
          opacity: 1,
          animation: 'bouncing-loader 0.6s infinite alternate',
        },
        '& > div:nth-of-type(2)': {
          animationDelay: '0.2s',
        },
        '& > div:nth-of-type(3)': {
          animationDelay: '0.4s',
        },
      }}
    >
      <Box></Box>
      <Box></Box>
      <Box></Box>
    </Box>
  );
};

export default BouncingDotsLoader;
